import React from 'react'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import { Page } from '../../../Parts/Page'
import { PayPalCard } from '../../../Parts/PayPalCard'

const styles = theme => ({
  paper: {
    padding: theme.spacing.unit * 2,
  }
})

class DonatePage extends React.Component {  
  render() {
    return (
      <Page pageMaxWidth={"600px"}>
        <Grid container spacing={16}>
          <Grid item xs={12}>
            <PayPalCard/>
          </Grid>
        </Grid>
      </Page>
    )
  }
}

export default withStyles( styles, { withTheme: true })( DonatePage )



// WEBPACK FOOTER //
// ./src/Pages/Donate/components/DonatePage.js